import { useAuth, SELECTED_TEAM_ID_KEY } from '@/dc-shared-web/src'
import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

export const useTeamUuid = () => {
  const { user } = useAuth()
  const searchParams = useSearchParams()

  const teamUuid = useMemo(() => {
    /* team uuid from the url. */
    const teamUuid = searchParams.get(SELECTED_TEAM_ID_KEY)

    /* team uuid from the user object. */
    const userCurrentTeamUuid = user?._currOfficeUUID

    /* team uuid from the first team the user is part of. */
    const userFirstTeamUuid = user?.teams?.[0]?.id

    return teamUuid || userCurrentTeamUuid || userFirstTeamUuid
  }, [user, searchParams])

  return teamUuid
}
